import { FC } from 'react';
import { LoaderCircle } from 'lucide-react';
import styled from 'styled-components';

const StyledLoader = styled(LoaderCircle)<{ $color?: string }>`
  animation: spin 1s linear infinite;
  color: ${({ theme, $color }) => $color || theme.colors.grey[400]};

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

type Size = 'small' | 'large' | 'xl';

type Props = {
  size?: Size;
  color?: string;
};

const loaderSize: Record<Size, number> = {
  small: 16,
  large: 24,
  xl: 40,
};

const Loader: FC<Props> = ({ size = 'small', color }) => {
  return <StyledLoader size={loaderSize[size]} $color={color} />;
};

export default Loader;
